import React, { useEffect, useRef } from "react";

const Stepper = ({ steps, currentStep, showStepName = false }) => {
  const stepRefs = useRef([]);

  useEffect(() => {
    if (stepRefs.current[currentStep]) {
      stepRefs.current[currentStep].scrollIntoView({
        behavior: "smooth",
        inline: "center", // center horizontally
        block: "nearest",
      });
    }
  }, [currentStep]);

  return (
    <div className="step-navigation">
      {steps.map((step, index) => (
        <div
          key={step.id || index}
          ref={(el) => (stepRefs.current[index] = el)}
          className={`step-item ${
            index === currentStep
              ? "active"
              : index < currentStep
              ? "done"
              : "pending"
          }`}
        >
          <div className="step-indicator">
            <div className="step-dot">
              {index < currentStep && (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="8" cy="8" r="8" fill="#03BF43" />
                  <path
                    d="M10.9068 5.59438C10.7898 5.47733 10.6002 5.47733 10.4835 5.59438L6.50329 9.57455L5.51698 8.58891C5.40027 8.47187 5.21034 8.47187 5.09364 8.58891C4.9766 8.70594 4.9766 8.89555 5.09364 9.01225L6.25415 10.1728C6.28495 10.2036 6.32123 10.2251 6.35955 10.2398C6.40713 10.2689 6.4588 10.2884 6.51253 10.2884C6.58918 10.2884 6.66585 10.2593 6.72437 10.2008L10.9068 6.01806C11.0238 5.90103 11.0238 5.71142 10.9068 5.59439V5.59438H10.9068Z"
                    fill="white"
                  />
                </svg>
              )}

              {index === currentStep && (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="8" cy="8" r="8" fill="#FCE4E5" />
                  <circle cx="8.00008" cy="8.00008" r="5.33333" fill="#F6ABAE" />
                  <circle cx="8.00008" cy="8.00008" r="3.33333" fill="#97262A" />
                </svg>
              )}

              {index > currentStep && (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="8" cy="8" r="8" fill="#AFB0B1" />
                </svg>
              )}
            </div>
          </div>

          <div className="step-label">
            {showStepName ? step.label?.en_US : `Step ${index + 1}`}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Stepper;